module.exports = __webpack_public_path__ + "static/media/codeanywhere-logo-full-color.870cf3f3.svg";